import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import { FaPhoneAlt } from 'react-icons/fa';
import { formatUSPhone } from '../../utils/phoneUtils';
import type { Stylist } from './types';

interface StylistGridMobileProps {
  stylists: Stylist[];
}

const StylistGridMobile: React.FC<StylistGridMobileProps> = ({ stylists }) => {
  return (
    <section className="w-full" aria-label="Stylists">
      <Swiper
        modules={[Autoplay, Pagination]}
        loop
        centeredSlides
        slidesPerView={1}
        spaceBetween={16}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
          dynamicBullets: true,
        }}
        className="stylists-swiper-mobile"
      >
        {stylists.map((stylist) => (
          <SwiperSlide key={stylist.id}>
            <div className="flex justify-center px-3 py-5">
              <article
                className="
                  w-full
                  max-w-[320px] sm:max-w-[360px]
                  rounded-2xl
                  overflow-hidden
                  shadow-md
                  transition-shadow duration-300
                  hover:shadow-xl
                "
              >
                {/* IMAGE */}
                <div className="relative w-full aspect-[4/5] bg-gray-100">
                  <img
                    src={stylist.image}
                    alt={`${stylist.name} - ${stylist.role}`}
                    loading="lazy"
                    className="
                      w-full h-full
                      object-cover
                      transition-transform duration-500
                      hover:scale-105
                    "
                  />
                </div>

                {/* CONTENT */}
                <div className="p-4 sm:p-5 flex flex-col gap-2">
                  {/* NAME */}
                  <h3 className="
                    text-base sm:text-lg md:text-xl
                    font-bold text-gray-900 dark:text-white
                    leading-tight
                  ">
                    {stylist.name}
                  </h3>

                  {/* ROLE */}
                  <p className="
                    text-sm sm:text-base
                    font-medium
                    text-primary dark:text-rose-400
                  ">
                    {stylist.role}
                  </p>

                  {/* CTA */}
                  {stylist.phone && (
                    <a
                      href={formatUSPhone(stylist.phone)}
                      className="
                        mt-3
                        flex items-center justify-center gap-2
                        w-full
                        min-h-[44px]
                        rounded-lg
                        bg-primary
                        text-white
                        text-sm sm:text-base
                        font-semibold
                        active:scale-[0.98]
                        transition
                        focus:outline-none
                        focus:ring-2
                        focus:ring-primary
                        focus:ring-offset-2
                      "
                      aria-label={`Call ${stylist.name}`}
                    >
                      <FaPhoneAlt className="text-sm" />
                      Book Now
                    </a>
                  )}
                </div>
              </article>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default StylistGridMobile;
